export default {
  mobileBreakpoint: On.MediaQueries.width.larger,
  transitionTime: 300,
  subnavOpenDelay: 350,
  subnavOpenClass: 'subnav-is-open',
  teaserLinkClass: 'sub-navigation__teaser-link',
}
